import React, { useCallback, useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import Loading from 'custom/assets/loaders/Loading'
import PortfolioService from '../../services/portfolio.service'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import NumberFormat from 'react-number-format'
import CustomPagination from '../../components/pagination'
import AddIcon from 'custom/assets/common-icons/Add.svg'
import { useTranslation } from 'react-i18next'
import { DEPOSITS_KEYS } from '../../utils/translation-constants'
import { getMenuListSelector } from '../../store/selectors/app.selector'
import { useSelector } from 'react-redux'

export default function DepositView() {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [viewLoader, setViewLoader] = useState(false)
  const [stage, setStage] = useState(0)
  const [depositList, setDepositList] = useState([])
  const [noRecords, setNoRecords] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const [depositDetails, setDepositDetails] = useState({})
  const [depositStatementDetails, setDepositeStatementDetails] = useState([])
  const [tabIndex, setTabIndex] = useState(1)
  const [expandedStatement, setExpandedStatement] = useState(null)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(5)
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['DEPOSIT'] || {}

  useEffect(() => {
    getAccountDetails()
  }, [])

  const getAccountDetails = useCallback(async () => {
    try {
      setLoading(true)
      const response = await PortfolioService.getAccountDetails({
        accountType: 'S',
      })
      if (response.status === 200) {
        setLoading(false)
        response.data['accountSummaryDetails'].forEach((element) => {
          element.isActive = false
        })
        setNoRecords(response.data['accountSummaryDetails'].length > 0 ? false : true)
        setDepositList(response.data['accountSummaryDetails'])
        setStage(1)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const getDepositDetails = useCallback(async (selected) => {
    try {
      setViewLoader(true)
      const response = await PortfolioService.getDepositDetails(selected)
      if (response.status === 200) {
        setViewLoader(false)
        setDepositDetails(response.data)
      }
    } catch (err) {
      setViewLoader(false)
    }
  }, [])

  const getDepositeStatement = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        const response = await PortfolioService.getDepositeStatement(selected)
        if (response.status === 200) {
          setLoading(false)
          setDepositeStatementDetails(response.data[ 'depositEntriesList' ])
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [depositList],
  )

  // const handleChange = useCallback((value) => {
  //   setExpandedStatement(null)
  //   setMinValue((value - 1) * 5)
  //   setMaxValue(value * 5)
  // }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderList()
      default:
        return renderList()
    }
  }

  function renderView() {
    return (
      <>
        {!viewLoader && (
          <Row>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.ACCOUNT_NO)}</label>
              <span>{depositDetails.accountNo || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.ACC_DESC)}</label>
              <span>{depositDetails.accDesc || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.ACCOUNT_OPEN_DATE)}</label>
              <span>{depositDetails.accountOpenDate || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.BRN_CODE)}</label>
              <span>{depositDetails.brnCode || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.CURRENCY)}</label>
              <span>{depositDetails.currency || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.CUSTOMER_ID)}</label>
              <span>{depositDetails.customerId || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.DEBIT_ACC)}</label>
              <span>{depositDetails.debitAcc || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.DEBIT_ACC_BRN)}</label>
              <span>{depositDetails.debitAccBrn || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.MATURITY_AMT)}</label>
              <span>
                <NumberFormat
                  value={depositDetails.maturityAmt || '-'}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.MATURITY_DATE)}</label>
              <span>{depositDetails.maturityDate || '-'}</span>
            </Col>
            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.PROD_CATEGORY)}</label>
              <span>{depositDetails.prodCategory || '-'}</span>
            </Col>

            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.STATUS)}</label>
              <span>{depositDetails.status || '-'}</span>
            </Col>

            <Col xs={'auto'} sm={'auto'} md={'auto'}>
              <label>{t(DEPOSITS_KEYS.TD_AMT)}</label>
              <span>
                <NumberFormat
                  value={depositDetails.tdAmt || '-'}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </span>
            </Col>
          </Row>
        )}
      </>
    )
  }

  function renderStatement() {
    return (
      <>
        {depositStatementDetails.length === 0 && (
          <div className='no-data-found'>{t(DEPOSITS_KEYS.NO_STATEMENT)} </div>
        )}
        {depositStatementDetails.slice(minValue, maxValue).map((option, index) => (
          <div key={index} className='approval-card' style={{ backgroundColor: '#fff' }}>
            <div
              className='approval-card-header'
              onClick={async () => {
                if (expandedStatement == index) {
                  setExpandedStatement(null)
                } else {
                  setExpandedStatement(index)
                }
              }}>
              <span>
                {t(DEPOSITS_KEYS.REF_NUMBER)} : {option.refNo}
              </span>
              <NumberFormat
                value={option?.amount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </div>

            {expandedStatement === index && (
              <div className='approval-card-body'>
                <Row>
                  <Col xs={'auto'} sm={'auto'} md={'auto'}>
                    <label>{t(DEPOSITS_KEYS.ACC_NO)}</label>
                    <span>{option.accNo}</span>
                  </Col>

                  <Col xs={'auto'} sm={'auto'} md={'auto'}>
                    <label>{t(DEPOSITS_KEYS.AMOUNT)}</label>
                    <span>
                      <NumberFormat
                        value={option.amount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                    </span>
                  </Col>

                  <Col xs={'auto'} sm={'auto'} md={'auto'}>
                    <label>{t(DEPOSITS_KEYS.REF_NO)}</label>
                    <span>{option.refNo}</span>
                  </Col>
                  <Col xs={'auto'} sm={'auto'} md={'auto'}>
                    <label>{t(DEPOSITS_KEYS.SL_NUMBER)}</label>
                    <span>{option.slNumber}</span>
                  </Col>
                  <Col xs={'auto'} sm={'auto'} md={'auto'}>
                    <label>{t(DEPOSITS_KEYS.TRANSACTION_DATE)}</label>
                    <span>{option.transactionDate}</span>
                  </Col>

                  <Col xs={'auto'} sm={'auto'} md={'auto'}>
                    <label>{t(DEPOSITS_KEYS.NARRATION)}</label>
                    <span>{option.narration}</span>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        ))}
        <div>
          {depositStatementDetails.length > 5 && (
            <CustomPagination
              defaultPageSize={5}
              setMaxValue={(value) => setMaxValue(value)}
              setMinValue={(value) => setMinValue(value)}
              totalLength={depositStatementDetails.length}
              defaultCurrent={1}
            />
          )}
        </div>
      </>
    )
  }

  function renderList() {
    return (
      <>
        {noRecords && <div className='no-data-found'>{t(DEPOSITS_KEYS.NO_ACCOUNTS)} </div>}

        {depositList.map((option, index) => (
          <div key={index} className='approval-card'>
            <div
              className='approval-card-header'
              onClick={async () => {
                if (expanded == index) {
                  setExpanded(null)
                  setExpandedStatement(null)
                } else {
                  setTabIndex(1)
                  setExpanded(index)
                  setExpandedStatement(null)
                  setMaxValue(5)
                  setMinValue(0)
                  await getDepositDetails(option)
                  await getDepositeStatement(option)
                }
              }}>
              <span>
                {t(DEPOSITS_KEYS.ACCOUNT_NUMBER)} - {option?.accountNo}
              </span>
              <span className='d-flex'>
                {option.currency}
                <NumberFormat
                  style={{ marginLeft: 10 }}
                  value={option?.avlBal}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </span>
            </div>

            {expanded === index && (
              <div className='approval-card-body'>
                <div className='row tab-navbar'>
                  <div className={tabIndex === 1 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(1)
                        setExpandedStatement(null)
                      }}>
                      {t(DEPOSITS_KEYS.VIEW_DETAILS)}
                    </span>
                  </div>
                  <div className={tabIndex === 2 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(2)
                      }}>
                      {t(DEPOSITS_KEYS.STATEMENT_DETAILS)}
                    </span>
                  </div>
                </div>
                {loading && renderLoading()}
                {tabIndex === 1 && !loading && renderView()}
                {tabIndex === 2 && !loading && renderStatement()}
              </div>
            )}
          </div>
        ))}
      </>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='DEPOSIT_VIEW' keyPath={'DEPOSIT'} showEmptySpace={true}>
      <div className='row mb-2'>
        <div className='col-7 d-flex'>
          <div className='heading-style'>{t(DEPOSITS_KEYS.HEADER)}</div>
        </div>
        {menuConfig['CREATE_TERM_DEPOSIT'] && (
          <div className='col-5 text-right'>
            <button
              tabIndex={'1'}
              onClick={() => history.push('/deposits/create-term-deposits')}
              type='button'
              className='btn p-2 detailed-statement-btn'>
              <img width={25} height={25} src={AddIcon} />
              <span style={{ marginLeft: 10 }} className='font-weight-600'>
                {t(DEPOSITS_KEYS.CREATE_DEPOSIT)}
              </span>
            </button>
          </div>
        )}
      </div>
      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
